import Store from "@/store";

export default function authHeader() {
  const token = Store.getters["auth/token"];
  const provider = Store.getters["auth/provider"];

  if (!token || !provider) {
    return {};
  }

  switch (provider) {
    case "msal":
      return {
        Authorization: `Bearer ${token}`,
      };
    case "local":
      return {
        "x-access-token": token,
      };
    default:
      return {};
  }
}
